<template>
  <div class="hold-transition">
    <loading v-if="cargando" />
    <div class="wrapper">
      <div class="content-wrapper">
        <section class="content-header">
          <div class="container-fluid">
            <div class="row">
              <div class="col-sm-6">
                <h5 class="mb-0">Sitios TEP</h5>
              </div>
              <div class="col-sm-6">
                <ol class="breadcrumb float-sm-right">
                  <li class="breadcrumb-item"><router-link to="/">Home</router-link></li>
                  <li class="breadcrumb-item active">TEP</li>
                  <li class="breadcrumb-item active">General</li>
                  <li class="breadcrumb-item active">Sitios</li>
                  <li class="breadcrumb-item active">Formulario</li>
                </ol>
              </div>
            </div>
          </div>
        </section>
        <section class="content">
          <div class="container-fluid">
            <div class="card">
              <div class="card-body">
                <div class="row">
                  <div class="col-md-3">
                    <label>Código</label>
                    <input type="text" class="form-control form-control-sm" v-model="form.codigo" />
                  </div>
                  <div class="col-md-3">
                    <label>Nombre</label>
                    <input type="text" class="form-control form-control-sm" v-model="form.nombre" />
                  </div>
                  <div class="col-md-3">
                    <label>Sigla</label>
                    <input type="text" class="form-control form-control-sm" v-model="form.sigla" />
                  </div>
                  <div class="col-md-3">
                    <label>Bloque</label>
                    <v-select
                      class="form-control form-control-sm p-0"
                      :class="$store.getters.getDarkMode ? 'dark-vselect' : ''"
                      v-model="bloque"
                      label="nombre"
                      :options="listasForms.bloques"
                      @input="onBloqueChange"
                    />
                  </div>
                  <div class="col-md-3">
                    <label>Ciudad</label>
                    <v-select
                      class="form-control form-control-sm p-0"
                      :class="$store.getters.getDarkMode ? 'dark-vselect' : ''"
                      v-model="ciudad"
                      label="nombre"
                      :options="listasForms.ciudades"
                      @input="onCiudadChange"
                    />
                  </div>
                  <div class="col-md-3">
                    <label>Dirección</label>
                    <input
                      type="text"
                      class="form-control form-control-sm"
                      v-model="form.dirreccion"
                    />
                  </div>
                  <div class="col-md-3">
                    <label>Estado</label>
                    <select class="form-control form-control-sm" v-model="form.estado">
                      <option value="">Seleccione...</option>
                      <option
                        v-for="estado in listasForms.estados"
                        :key="estado.numeracion"
                        :value="estado.numeracion"
                      >
                        {{ estado.descripcion }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="card-footer">
                <button class="btn bg-primary btn-sm" @click="save()">
                  <i class="fas fa-paper-plane"></i> Guardar
                </button>
                <button class="btn bg-secondary btn-sm ml-2" @click="back()">
                  <i class="fas fa-reply"></i> Volver
                </button>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import vSelect from "vue-select";
import Loading from "../../../../components/Loading";

export default {
  name: "TepSitioForm",
  components: { Loading, vSelect },
  data() {
    return {
      cargando: false,
      metodo: "POST",
      bloque: null,
      ciudad: null,
      form: {
        id: null,
        codigo: null,
        nombre: null,
        sigla: null,
        bloque_id: null,
        ciudad_id: null,
        departamento_id: null,
        dirreccion: null,
        tipo_sitio: null,
        estado: 1,
      },
      listasForms: {
        bloques: [],
        ciudades: [],
        estados: [],
      },
    };
  },
  methods: {
    getBloques() {
      axios.get("/api/tep/bloques/lista").then((response) => {
        this.listasForms.bloques = response.data;
      });
    },
    getCiudades() {
      axios.get("/api/admin/ciudades/lista").then((response) => {
        this.listasForms.ciudades = response.data;
      });
    },
    getEstados() {
      axios.get("/api/lista/1").then((response) => {
        this.listasForms.estados = response.data;
      });
    },
    onBloqueChange() {
      this.form.bloque_id = this.bloque ? this.bloque.id : null;
    },
    onCiudadChange() {
      this.form.ciudad_id = this.ciudad ? this.ciudad.id : null;
      this.form.departamento_id = this.ciudad ? this.ciudad.departamento_id : null;
    },
    getData() {
      if (!this.$route.params.id) return;
      this.metodo = "PUT";
      this.cargando = true;
      axios
        .get("/api/tep/sitios/show/" + this.$route.params.id)
        .then((response) => {
          this.form = response.data;
          this.bloque = response.data.bloque || null;
          this.ciudad = response.data.ciudad || null;
          this.cargando = false;
        })
        .catch(() => {
          this.cargando = false;
        });
    },
    save() {
      this.cargando = true;
      axios({
        method: this.metodo,
        url: "/api/tep/sitios",
        data: this.form,
      })
        .then(() => {
          this.$swal({
            icon: "success",
            title: "Sitio guardado exitosamente...",
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
          this.cargando = false;
          this.back();
        })
        .catch(() => {
          this.cargando = false;
        });
    },
    back() {
      return this.$router.replace("/tep/General/Sitios");
    },
  },
  mounted() {
    this.getBloques();
    this.getCiudades();
    this.getEstados();
    this.getData();
  },
};
</script>
